// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useQuery } from '@tanstack/react-query';

export const COIN_GECKO_SAFE_URL = 'https://api.coingecko.com/api/v3/simple/price?ids=safe&vs_currencies=usd&include_24hr_change=true&include_24hr_vol=true&include_market_cap=true';

export interface SafeCoinData {
	price: number;
	priceChange24h: number;
	volume24h: number;
	marketCap: number;
}

export function useSafeCoinData() {
	return useQuery({
		queryKey: ['safe-coin-data'],
		queryFn: async (): Promise<SafeCoinData> => {
			const response = await fetch(COIN_GECKO_SAFE_URL);
			if (!response.ok) {
				throw new Error('Failed to fetch Safe coin data');
			}
			const data = await response.json();
			
			return {
				price: data.safe?.usd || 0,
				priceChange24h: data.safe?.usd_24h_change || 0,
				volume24h: data.safe?.usd_24h_vol || 0,
				marketCap: data.safe?.usd_market_cap || 0,
			};
		},
		staleTime: 5 * 60 * 1000, // 5 minutes
		gcTime: 10 * 60 * 1000, // 10 minutes
	});
}
